import { render, staticRenderFns } from "./leaseOrders.vue?vue&type=template&id=227078e6&scoped=true"
import script from "./leaseOrders.vue?vue&type=script&lang=js"
export * from "./leaseOrders.vue?vue&type=script&lang=js"
import style0 from "./leaseOrders.vue?vue&type=style&index=0&id=227078e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227078e6",
  null
  
)

export default component.exports